import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { equals, map, prop } from 'ramda';
import { Button, Message, Radio } from '@fasstech/middle-design-system';
import classNames from 'classnames';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';

const RadioButton = ({ options, field, RadioButtonProps = {}, isDisplayed = true, ...props }) => {
  if (!isDisplayed) {
    return null;
  }
  return (
    <div className={classNames('flex gap-x-3.5', RadioButtonProps.containerClassName)}>
      {map(
        (option) => (
          <Button
            disabled={option.disabled || props.disabled}
            key={`${prop('name', field)}-${prop('value', option)}`}
            variant={equals(prop('value', field), prop('value', option)) ? 'primary' : 'secondary'}
            onClick={() => field.onChange(prop('value', option))}>
            {option.label}
          </Button>
        ),
        options
      )}
    </div>
  );
};

const ControlledRadio = ({
  name,
  form,
  rules,
  label,
  hideLabel = false,
  variant = 'radio',
  containerClassName = '',
  extraChange = () => {},
  isDisplayed = true,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }
  const labelClasses = hideLabel ? 'hidden' : '';

  const RadioComponent = useMemo(
    () => (equals(variant, 'button') ? RadioButton : Radio),
    [variant]
  );

  return (
    <div className={`w-full md:w-[100%]! ${containerClassName}`}>
      <label className={labelClasses}>
        {label} {prop('required', rules) && '*'}
      </label>
      <Controller
        name={name}
        control={form.control}
        rules={rules}
        render={(props) => (
          <RadioComponent
            withIndicator
            error={getErrorMessage(form.formState.errors, name)}
            {...props}
            {...props.field}
            {...extraProps}
            onChange={(e) => {
              props.field.onChange(e.target.value);
              extraChange(e.target.value);
            }}
          />
        )}
      />
      <Message variant="error" label={getErrorMessage(form.formState.errors, name)} />
    </div>
  );
};

export default ControlledRadio;
